import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function UploadLithostratBreadcrumbWrapper() {
  useBreadcrumb('routes/upload/lithostrat', 'Lithostratigraphy');
  return <Outlet />;
}
